import { render, staticRenderFns } from "./cailist.vue?vue&type=template&id=b078e36e&scoped=true"
import script from "./cailist.vue?vue&type=script&lang=js"
export * from "./cailist.vue?vue&type=script&lang=js"
import style0 from "./cailist.vue?vue&type=style&index=0&id=b078e36e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b078e36e",
  null
  
)

export default component.exports